/* Func = limiting Scope for this file */
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let third_footer_ul_nav = document.querySelector( "#third-footer-ul_nav" )
    if( third_footer_ul_nav ){

        let li = document.createElement( "li" )
        li.classList.add( "tertiary-navigation__item" )
        li.classList.add( "third-nav-6" )
        
        let p = document.createElement( "p" )
        p.classList.add( "uk-text-small" )

        let a = document.createElement( "a" )
        a.classList.add( "ot-sdk-show-settings" )
        a.setAttribute( "nohref", "nohref" )
        a.style = "cursor:pointer;"
        a.innerText = "Cookie Preferences"

        p.appendChild( a )
        li.appendChild( p )
        third_footer_ul_nav.appendChild( li )

    }


    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        /*is explorer*/
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
        *****************************************************/
        let scrollParallax = []
        let scrolled = 0

        /* screen height */
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") /* get it from html */
            /*get distance in positive value*/
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                /*get distance in negative value (to do the scroll inverse)*/
                distance = distance * -1
            }
            /*Equivalent distance using screen height + element height*/
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function () {
                /*Obtain the distance between top screen and document top 0*/
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                /*Distance of bottom page to top of the element*/
                let relative_distance = scrolled + v_height - topElement
                /*transpoling data to move the parallax element relative to the scroll of all the screen*/
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                /*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, /* relative to document viewport */
                rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
                threshold: 0 /* visible amount of item shown in relation to root */
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
        ***********************************************************************************/
    }

    /* Text and Form Animations */
    let formModule = document.querySelectorAll('.form-module-wrapper form');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
    if(textModule){
        textModule.forEach(function(text_module) {
            text_module.classList.add('animate-fade', 'top');
        });
    }

    /* Opening and Closing Menu */
    let Body = document.body;

    document.addEventListener('DOMContentLoaded', () => {

        // Main Nav Dropdown
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }

        let secondaryNav = document.getElementById('secondary-header-ul_nav');
        if(secondaryNav){
            secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
                secondary_nav.addEventListener("mouseover", (event) => {
                    secondary_nav.classList.add('hover');
                    if(secondary_nav.querySelector('ul.submenu')){
                        secondary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                secondary_nav.addEventListener("mouseout", (event) => {
                    secondary_nav.classList.remove('hover');
                    if(secondary_nav.querySelector('ul.submenu')){
                        secondary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }

        /* Lightbox Gallerys */
        const customLightbox = new LBX('.js-lbx-gallery', {
            customClass:'lbx-gallery',
        });

        //Change carrers nav from set-two to set-one
    /*
        let set_one_footer = document.querySelector('.footer .set-one .address');
        let set_one_footer_contact_link = document.querySelector('.footer .set-one .address a.link');
        let set_two_footer = document.querySelector('.footer .set-two #third-footer-ul_nav');
        let carrers_nav_link = document.querySelector('.footer .set-two .carrers-nav ');
        let carrers_nav_node = document.querySelector('.footer .set-two .third-nav-1 ');
        
        if (set_one_footer && set_two_footer && carrers_nav_link && carrers_nav_node && set_one_footer_contact_link){
            set_two_footer.removeChild(carrers_nav_node);
            set_one_footer.insertBefore(carrers_nav_link, set_one_footer_contact_link);
            carrers_nav_link.classList.add('link');
        } 
    */

    });

    window.addEventListener("load", function() {
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        });
    });

    /* Remove empty <p> tags created by tinymce */
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    /* Swiper Sliders */

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        const imaSlider = new Swiper('.images-sliders', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            },
            navigation: {
                nextEl: ".sw-but-img-next",
                prevEl: ".sw-but-img-prev",
            },
        });
    }

    let events_slider = document.querySelector('.events-slider_slider-2');
    if(events_slider) {
        const events_slider_swipper = new Swiper('.events-slider_slider-2', {
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            },
            navigation: {
                nextEl: ".swiper-event-button-next",
                prevEl: ".swiper-event-button-prev",
            },
        });
    }

    

    if (document.querySelectorAll(".events-slider_slider")){
        let swiper = new Swiper(".events-slider_slider", {
            slidesPerView: 2.2,
            spaceBetween: 40,
            pagination: {
                el: ".events-slider_slide-pagination",
                clickable: true,
            },
        });
    }
    if (document.querySelectorAll(".events-slider_slider-mobile")){
        let swiper = new Swiper(".events-slider_slider-mobile", {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: ".events-slider_slide-pagination",
                clickable: true,
            },
        });
    }

    let gallerySlide = document.querySelectorAll('.gallery-slider');
    if(gallerySlide){
        const gallerySlider = new Swiper('.gallery-slider', {
            /*Optional parameters*/
            loop: true,
            slidesPerView: 2,
            spaceBetween: 40,
            // effect: "fade",
            // fadeEffect: {
            //     "crossFade": true
            // },
            // navigation: {
            //     nextEl: ".sw-but-next",
            //     prevEl: ".sw-but-prev",
            // },
            pagination: {
                el: '.slider-pagination',
                clickable: true,
            }
        });
    }


    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                /*Optional parameters*/
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                /* If we need pagination */
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let carouselSlide = document.querySelectorAll('.carousel-slider');
    if(carouselSlide){
        const carouselSlider = new Swiper('.carousel-slider', {
            slidesPerView: 1,
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                840: {
                    slidesPerView: 3,
                    autoHeight: false,
                },
                700: {
                    slidesPerView: 2,
                    autoHeight: false,
                },
            },
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        const sliderSlider = new Swiper('.slider-slide', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            /* If we need pagination */
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                640: {
                    autoHeight: false,
                },
            },
        });
    }

    let reviewsSlider = document.querySelectorAll('.reviews-slides');
    if(reviewsSlider){
        reviewsSlider.forEach((item)=> {
            new Swiper('.reviews-slides', {
                autoHeight: true,
                loop: false,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                }
            });
        });
    }

    let historySlide = document.querySelectorAll('.history-slide');
    if(historySlide){
        const historySlider = new Swiper('.history-slide', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                600: {
                    autoHeight: false,
                },
            },
        });
    }

    let locationTap = document.querySelectorAll('.location-int-block');
    let locationSlide = document.querySelectorAll('.location-slider');
    if(locationSlide){
        const locationSlider = new Swiper('.location-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        locationTap.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.location-point');
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(locationTap.length > 1){
                        locationSlider[hBc].slideTo(navCount, 1000);
                    } else {
                        locationSlider.slideTo(navCount, 1000);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(locationTap.length > 1){
                    locationSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    locationSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider.realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                }
            });
        });
    }

    let carouselColumnsSlide = document.querySelectorAll('.carousel-columns-slide');
    if(carouselColumnsSlide){
        const carouselColumnsSlider = new Swiper('.carousel-columns-slide', {
            watchSlidesProgress: true,
            slidesPerView: 1,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                840: {
                    slidesPerView: 3,
                    autoHeight: false,
                },
                700: {
                    slidesPerView: 2,
                    autoHeight: false,
                },
            },
        });
    }

    /* Scroll Intro*/
    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    /* FAQ */
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    /* Anchor Animation */
    let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-lbx], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
    if(aHref){
        aHref.forEach(function(a_href) {
            if(a_href.getAttribute('href') != '#/booking/step-1'){
                a_href.addEventListener('click', function(e){
                    e.preventDefault();
                    let strAnchor = this.hash.slice(1);
                    animateto(strAnchor);
                });
            }
        });
    }

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    /* Open Navigation */
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        /* Sub-Navigation */
        /* Open active sub-nav on load */
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        /* Toggle open/close on tap */
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                entry.classList.add('parent-in');
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                        this.classList.remove('active');
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                        this.classList.add('active');
                    }
                });
            }
        });
    }

    //remove click for active links
    document.querySelectorAll('a').forEach(link => {
        if(link.classList.contains('active')){
            link.addEventListener('click', function(e){
                e.preventDefault();
            })
        }
        if(link.classList.contains('no-link')){
            link.addEventListener('click', function(e){
                e.preventDefault();
            })
        }
    })

    /* Close Navigation */
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

    let screenHeight = document.documentElement.clientHeight;
    let homeTopImg = document.querySelector('.hero-top');
    if(homeTopImg){
        homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
            entry.style.height = screenHeight+'px';
        });
        window.addEventListener("resize", function(){
            screenHeight = document.documentElement.clientHeight;
            homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
                entry.style.height = screenHeight+'px';
            });
        });
    }

    let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
    if(aBtn){
        setTimeout(() => {
            aBtn.forEach(function(a_btn) {
                let htmlString = a_btn.innerText;
                a_btn.innerHTML = '<span>'+htmlString+'</span>';
            });
        }, 500);
    }


    /* membership-application */

    if(document.querySelector("#form_id-3191")) {
        document.querySelector("#form_id-3191 .step-1 .fileupload label[for='id_12_3191']").classList.remove('hidden')
 
    

  

        let activeForm = document.querySelector("#active-form");

        let formInfo = document.getElementById("form-info");
        let formDate = document.getElementById("form-data");
        let formTerm = document.getElementById("form-term");
        let bottonActiveForm = document.getElementById("botton-continue");
        let bottonBack = document.querySelector("#botton-continue #save-go-back");
        let bottonContinue = document.querySelector("#botton-continue #continue");
        let stepNumb1 = document.querySelector("#form_id-3191 .step-1");
        let stepNumb2 = document.querySelector("#form_id-3191 .step-2");
        let stepNumb3 = document.querySelector("#form_id-3191 .step-3");
        let stepNumb4 = document.querySelector("#form_id-3191 .step-4");
        let imageHeroMobile = document.getElementById("image-hero-mobile");
        let imageLogoMobile = document.getElementById("image-logo-mobile");



        activeForm.addEventListener( 'click', ()=> {
            formInfo.classList.add("hidden");
            formTerm.classList.add("hidden");
            formDate.classList.remove("hidden");
            bottonActiveForm.classList.remove("hidden");
            //   formDate.querySelector('div[aria-label="GDPR Policy"]').classList.add('hidden');
            formDate.querySelector('div.form-module__submit').classList.add('hidden');
            imageHeroMobile.classList.add("hidden");
            imageLogoMobile.classList.remove("hidden");
            window.scrollTo({
                top: 0, 
                behavior: 'smooth' 
            });

        } )

        bottonBack.addEventListener("click", ()=> {
            let errorBanner = document.querySelector(".error-banner-input");
            if( !stepNumb1.classList.contains("hidden")) {
                formInfo.classList.remove("hidden");
                formTerm.classList.remove("hidden");
                formDate.classList.add("hidden");
                bottonActiveForm.classList.add("hidden");
                errorBanner.classList.add('hidden');
                imageHeroMobile.classList.remove("hidden");
                imageLogoMobile.classList.add("hidden");

            } else if(!stepNumb2.classList.contains("hidden")) {
                stepNumb1.classList.remove("hidden");
                stepNumb2.classList.add("hidden");
                errorBanner.classList.add('hidden');
            } else if(!stepNumb3.classList.contains("hidden")) {
                stepNumb2.classList.remove("hidden");
                stepNumb3.classList.add("hidden");
                errorBanner.classList.add('hidden');
            } else if(!stepNumb4.classList.contains("hidden")) {
                stepNumb3.classList.remove("hidden");
                stepNumb4.classList.add("hidden");
                errorBanner.classList.add('hidden');
                formDate.querySelector('div[aria-label="GDPR Policy"]').classList.add('hidden');
                formDate.querySelector('div.form-module__submit').classList.add('hidden');
                document.querySelector('#continue').classList.remove('hidden');
            }
        })


        bottonContinue.addEventListener( 'click', ()=> {
   
            if ( !stepNumb1.classList.contains("hidden") && verifyInputsCurrentStep(stepNumb1)) {
                stepNumb1.classList.add("hidden");
                stepNumb2.classList.remove("hidden");
                window.scrollTo({
                    top: 0, 
                    behavior: 'smooth' 
                });
            } else if(!stepNumb2.classList.contains("hidden") && verifyInputsCurrentStep(stepNumb2)) {
                stepNumb2.classList.add("hidden");
                stepNumb3.classList.remove("hidden");
                window.scrollTo({
                    top: 0, 
                    behavior: 'smooth' 
                });
            } else if(!stepNumb3.classList.contains("hidden") && verifyInputsCurrentStep(stepNumb3) ) {
                stepNumb3.classList.add("hidden");
                stepNumb4.classList.remove("hidden");   
                // formDate.querySelector('div[aria-label="GDPR Policy"]').classList.remove('hidden');
                formDate.querySelector('div.form-module__submit').classList.remove('hidden');
                document.querySelector('#continue').classList.add('hidden');
                window.scrollTo({
                    top: 0, 
                    behavior: 'smooth' 
                });
            }

        } )

        function verifyInputsCurrentStep(current_step_page) {
            let all_inputs_required = current_step_page.querySelectorAll('input.required');
            let all_selector_required = current_step_page.querySelectorAll('select.required');
        
            for (let i = 0; i < all_inputs_required.length; i++) {
            let input = all_inputs_required[i];
        
            if (input.value.trim() === '') {
                console.log(input.value.trim());
                if (!current_step_page.querySelector('p.verify_message_fill_inputs')) {
                   let errorBanner = document.querySelector(".error-banner-input");
                   errorBanner.classList.remove("hidden");    
                   window.scrollTo({
                    top: 0, // Desplazar hasta la parte superior de la página
                    behavior: 'smooth' // Desplazamiento suave
                });                
                // let errorMessage = document.createElement('p');
                // errorMessage.classList.add('verify_message_fill_inputs');
                // errorMessage.textContent = 'Please fill all inputs required (*)';
                // current_step_page.appendChild(errorMessage);
                }
                return false;
            }
            }

            for (let x = 0; x < all_selector_required.length; x++) {
            let input = all_selector_required[x];
        
            if (input.value.trim() === '' || input.value.trim() === '---') {

                if (!current_step_page.querySelector('p.verify_message_fill_inputs')) {
                    let errorBanner = document.querySelector(".error-banner-input");
                    errorBanner.classList.remove("hidden");
                    window.scrollTo({
                        top: 0, // Desplazar hasta la parte superior de la página
                        behavior: 'smooth' // Desplazamiento suave
                    });
                // let errorMessage = document.createElement('p');
                // errorMessage.classList.add('verify_message_fill_inputs');
                // errorMessage.textContent = 'Please fill all inputs required (*)';
                // current_step_page.appendChild(errorMessage);
                }
                return false;
            }
            }

            let errorMessage = document.querySelector('.error-banner-input');
            if (errorMessage) {
            errorMessage.classList.add('hidden');
            }
        
            return true;
        }

        let formApply = document.getElementById("form_id-3191");
        let button_go_home = document.getElementById("return-home");

        formApply.addEventListener('submit',()=>{
            let myInterval = setInterval(() => {
                if( document.querySelector('p.form-module__confirmation').style.display != 'none' ){
                clearInterval(myInterval)
                    button_go_home.classList.remove('hidden')
                    document.querySelector('#save-go-back').classList.add('hidden');
                }
                }, 500);
                });

        let textarealabel = document.querySelector('.field_3191_34 > label');
        let textareaText = document.querySelector('.field_3191_34 > textarea');
        textarealabel.classList.remove("hidden");
        textareaText.placeholder = '';

    }

})();

function animateto(target){
var gotoTarget = offset(document.getElementById(target)).top - 80;
var from     = window.pageYOffset
var to       = gotoTarget
var duration = 1300;
var start = new Date().getTime()

/* Time Interval */
var timer = setInterval(function() {
    var time = new Date().getTime() - start

    if(from <= to ){
        var y = easeInOutQuart(time, from, to - from, duration)
    } else {

        var y = easeInOutQuart(time, from, -(from - to), duration)
    }
    window.scrollTo(0, y)
    if (time >= duration) clearInterval(timer)

}, 1000 / 60);

window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
    /* check scroll down or up for header styles */
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(header){
        if(st > 80){
            if (st > lastScrollTop){
                /* downscroll code */
                if(!header.classList.contains('down')){
                    header.classList.add('down');
                    header.classList.remove('up');
                }
            } else {
                /* upscroll code */
                if(!header.classList.contains('up')){
                    header.classList.add('up');
                    header.classList.remove('down');
                }
            }
        } else {
            if(header.classList.contains('up') || header.classList.contains('down')){
                header.classList.remove('up');
                header.classList.remove('down');
            }
        }
    }

    let SubMenu = document.getElementById('subMenuAnchor');
    if(SubMenu){
        let subPost = document.getElementById('subMenu');
        let subPosition = '';
        if(document.body.classList.contains('alert_open')){
            subPosition = offset(SubMenu).top - 120;
        } else {
            subPosition = offset(SubMenu).top - 80;
        }
        if(st > subPosition){
            if(!subPost.classList.contains('floating-up')){
                subPost.classList.add('floating-up');
            }
        } else {
            if(subPost.classList.contains('floating-up')) {
                subPost.classList.remove('floating-up');
            }
        }
    }

    lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

    //Scroll to booking btn

    let bodyContent = window.innerWidth;
        if(bodyContent > 600){
            const scrollButton = document.getElementById('booking-btn');
            const scrollTell = document.querySelector('.tel-booking');
    
            function handleScroll() {
                if (window.scrollY > 50) {
                    scrollButton.classList.add('scrolled');
                    scrollButton.classList.remove('booking-btn');
                    scrollTell.classList.add('scrollTell');
                } else {
                    scrollButton.classList.remove('scrolled');
                    scrollButton.classList.add('booking-btn');
                    scrollTell.classList.remove('scrollTell');
                }
            }
    
            window.addEventListener('scroll', handleScroll);
        }

}

let formLastFields = document.querySelectorAll('.gdpr-wrap');

formLastFields.forEach(field => {
    let container = document.createElement('div');
    container.className = 'field gdpr clearfix';
    
    let input = document.createElement('input');
    input.setAttribute('type', 'checkbox');
    input.setAttribute('id', 'email-signup_accept-sms-messages');
    input.setAttribute('name', 'accept-sms-messages');
    input.setAttribute('value', 'y');
    input.setAttribute('aria-required', 'true');

    
    let label = document.createElement('label');
    label.setAttribute('for', 'email-signup_accept-sms-messages');
    label.innerHTML = `I agree to be contacted by Kaiya Real Estate, LLC via call, email and text. To opt out, you can reply "stop" at any time or click the unsubscribe link in the emails. Message and data rates may apply. Messages frequency varies. Privacy Policy & Terms of Service <a href="https://www.kaiyabeachresort.com/privacy-policy" target="_blank"> the Kaiya privacy disclaimer </a>.`;

    container.appendChild(input);
    container.appendChild(label);
    
    field.appendChild(container);
});


/** Text Addition to First Required Checkbox **/

let firstRequiredCheckbox = document.querySelector('label[for="form_id-3342Inquire-privacy_termsemail-signup"]');
if(firstRequiredCheckbox){
    const br = document.createElement('br');
    firstRequiredCheckbox.appendChild(br);
    
    const additionalText = document.createTextNode('Data will not be shared with third parties for marketing or promotional purposes.');
    firstRequiredCheckbox.appendChild(additionalText);
}